<ng-content></ng-content>
<ng-container *ngIf="hasContextMenu && !isMemberField" >
      <div class="field-option-container" [ngStyle]="{'visibility': (displayFieldOptions || showFieldOptions) ? 'visible' : 'hidden'}">
        <button #FieldOptionsButton
            id="{{buttonId}}"
            [attr.tabindex]="isInAccessibilityMode || overrideTabbability ? 0 : -1"
            [attr.aria-haspopup]="true"
            attr.data-automation-id="lm-{{fieldAutomationId}}-fieldoptions"
            class="context-menu-button field-options-button"
            soho-button="icon"
              icon="more"
            soho-context-menu
              [lazyLoad]="true"
              [beforeOpen]="ajaxCallbackFunction"
              (selected)="contextMenuEventFunction($event)"
              (close)="onFieldOptionsContextMenuClose()"
            (click)="openFieldOptions($event)"
            (keydown.arrowDown)="openFieldOptions($event)"
            (keydown.space)="openFieldOptions($event)"
            (focus)="handleFocus()"
            (blur)="handleBlur()">
            <span class="audible">{{fieldOptionsLabel}}</span>
        </button>
        <div class="popupmenu-wrapper bottom" role="application">
          <ul class="popupmenu" attr.data-automation-id="lm-{{fieldAutomationId}}-popupmenu"></ul>
        </div>
      </div>
</ng-container>
